<template>
  <div  class="main">
    <el-container>
        <el-aside width="240px">
          <el-row >
            <el-col :span="24">
                <el-menu  background-color="#111a2c"
                         text-color="#ffffff" class="el-menu-vertical-demo" :default-active="this.$route.path">
                  <div class="el-header">
                    <td class="idiv">
                      <i class="el-icon-menu titlei"></i>
                    </td>
                    <td class="hdiv">
                      <h5>拓疆设备管理后台</h5>
                    </td>
                  </div>
                  <el-menu-item index="/data/useraccount" @click="showaccount('/data/useraccount')" style="padding-left: 52px;">
                    <i class="el-icon-s-order"></i>
                    <span slot="title">用户账户管理</span>
                  </el-menu-item>
                  <el-menu-item index="/data/appversion" @click="showappversion('/data/appversion')" style="padding-left: 52px;">
                    <i class="el-icon-document-copy"></i>
                    <span slot="title">app版本管理</span>
                  </el-menu-item>
                  <el-menu-item index="/data/productversion" @click="showproductversion('/data/productversion')" style="padding-left: 52px;">
                    <i class="el-icon-document-copy"></i>
                    <span slot="title">产品固件管理</span>
                  </el-menu-item>
<!--                  <el-submenu index="4" style="padding-left: 30px;"  >-->
<!--                    <template slot="title" >-->
<!--                      <i class="el-icon-document"></i>-->
<!--                      <span slot="title" >产品信息管理</span>-->
<!--                    </template>-->
<!--                    <el-submenu index="4-1">-->
<!--                      <span slot="title" style="padding-left: 20px;">清洗喷枪</span>-->
<!--                      <el-menu-item style="padding-left: 59px;" index="4-1-1" @click="gunsnmanage">设备绑定</el-menu-item>-->
<!--                      <el-menu-item style="padding-left: 59px;" index="4-1-2" @click="gunmonitor">登录信息</el-menu-item>-->
<!--                    </el-submenu>-->
<!--                    <el-submenu index="4-2">-->
<!--                      <span slot="title" style="padding-left: 20px;">消防吊桶</span>-->
<!--                      <el-menu-item style="padding-left: 59px;" index="4-2-1" @click="bucketsnmanage">设备绑定</el-menu-item>-->
<!--                      <el-menu-item style="padding-left: 59px;" index="4-2-2" @click="bucketmonitor">登录信息</el-menu-item>-->
<!--                    </el-submenu>-->
<!--                  </el-submenu>-->

                  <el-submenu index="4" style="padding-left: 30px;"  >
                    <template slot="title" >
                      <i class="el-icon-s-tools"></i>
                      <span slot="title" >产品信息管理</span>
                    </template>
                      <el-menu-item style="padding-left: 59px;" index="/data/gunproductsnbind" @click="gunsnmanage('/data/gunproductsnbind')">清洗喷枪</el-menu-item>
                      <el-menu-item style="padding-left: 59px;" index="/data/bucketproductsnbind" @click="bucketsnmanage('/data/bucketproductsnbind')">拓疆智载</el-menu-item>
                  </el-submenu>
                    <el-submenu index="5" style="padding-left: 30px;" >
                      <template slot="title" >
                        <i class="el-icon-document"></i>
                        <span slot="title" >设备信息管理</span>
                      </template>
                      <el-menu-item style="padding-left: 59px;" index="/data/gunlogininfo" @click="gunmonitor('/data/gunlogininfo')">清洗喷枪</el-menu-item>
                      <el-menu-item style="padding-left: 59px;" index="/data/bucketlogininfo" @click="bucketmonitor('/data/bucketlogininfo')">拓疆智载</el-menu-item>
                    </el-submenu>

<!--                  <el-menu-item index="5" @click="showbaidumap" style="padding-left: 52px;">-->
<!--                    <i class="el-icon-document-copy"></i>-->
<!--                    <span slot="title">地图管理</span>-->
<!--                  </el-menu-item>-->
                </el-menu>
            </el-col>
          </el-row>
            <el-footer>
              <div class="dropup">
                <button class="dropbtn">{{username}}</button>
                <div class="dropup-content">
                  <router-link to="/data/user">添加用户</router-link>
                  <a  @click="logout">退出</a>
                </div>
              </div>
            </el-footer>
        </el-aside>
      <router-view></router-view>
    </el-container>

  </div>
</template>

<script>
import router from '../router/index'
import axios from '../utils/request'
export default {
  data () {
    return {
      username: '',
      activeIndex: ''
    }
  },
  mounted () {
    this.username = this.$route.query.username

    if (this.username) {
      this.username = this.$route.query.username
      // 保存到本地存储
      localStorage.setItem('username', this.username)
    } else {
      this.username = localStorage.getItem('username')
    }
    // if (this.$route.path.startsWith('/data/useraccount')) {
    //   router.push('/data/useraccount')
    // } else if (this.$route.path.startsWith('/data/bucketproductsnbind')) {
    //   router.push('/data/bucketproductsnbind')
    // } else if (this.$route.path.startsWith('/data/gunproductsnbind')) {
    //   router.push('/data/gunproductsnbind')
    // } else if (this.$route.path.startsWith('/data/appversion')) {
    //   router.push('/data/appversion')
    // } else
    router.push(this.$route.path)
    this.activeIndex = this.$route.path
    console.log('this.$route', this.$route)
    console.log('username', this.username)
  },
  methods: {
    weclome: function () {
      axios.get('/data/welcome').then(res => {
        console.log('success')
      })
    },
    showaccount (val) {
      this.activeIndex = val
      router.push('/data/useraccount')
    },
    gunsnmanage (val) {
      this.activeIndex = val
      router.push('/data/gunproductsnbind')
    },
    bucketsnmanage (val) {
      this.activeIndex = val
      router.push('/data/bucketproductsnbind')
    },
    showappversion (val) {
      this.activeIndex = val
      router.push('/data/appversion')
    },
    showproductversion (val) {
      this.activeIndex = val
      router.push('/data/productversion')
    },
    logout () {
      console.log('router', router)
      axios.get('/user/loginOut').then(res => {
        console.log('success')
        router.push('/')
      })
    },
    gunmonitor (val) {
      this.activeIndex = val
      router.push('/data/gunlogininfo')
    },
    bucketmonitor (val) {
      this.activeIndex = val
      router.push('/data/bucketlogininfo')
    },
    showbaidumap () {
      router.push('/data/test')
    }
  }
}
</script>

<style scoped>
  .el-header{
    background-color: #111a2c;
    color: #ffffff;
    text-align: center;
    line-height: 60px;
    padding-left: 48px;
  }

  /*.el-aside {*/
  /*  background-color: #111a2c;*/
  /*  color: #333;*/
  /*  text-align: center;*/
  /*  line-height: 200px;*/
  /*  height:100vh;*/
  /*}*/

  .el-aside {
    background-color: #111a2c;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* 顶部内容在上，footer在底 */
    height: 100vh;
    padding: 0;
  }
  /*.el-footer {*/
  /*  background-color: #13ce66;*/
  /*  height: 60px; !* 自定义高度 *!*/
  /*  line-height: 60px;*/
  /*  text-align: center;*/
  /*  color: #fff;*/
  /*}*/
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-footer{
    /*background-color: #13ce66;*/
    height: 100vh;
  }

  /* 下拉按钮 */
  .dropbtn {
    background-color: #111a2c;
    color: white;
    padding: 16px;
    font-size: 16px;
    border: none;
  }

  /* 容器 <div> - 用于定位上拉菜单内容所需的元素 */
  .dropup {
    position: relative;
    display: inline-block;
  }

  /* 上拉菜单内容（默认隐藏） */
  .dropup-content {
    display: none;
    position: absolute;
    bottom: 50px;
    background-color: #f1f1f1;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }

  /* 下拉菜单中的链接 */
  .dropup-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
  }

  /* 更改鼠标悬停时下拉链接的颜色 */
  .dropup-content a:hover {background-color: #ddd}

  /* 鼠标悬停时显示上拉菜单 */
  .dropup:hover .dropup-content {
    display: block;
  }

  /* 当上拉菜单内容显示时，更改上拉按钮的背景色 */
  .dropup:hover .dropbtn {
    background-color: #111a2c;
  }

</style>



// WEBPACK FOOTER //
// src/components/Data.vue